import "./style.scss";
import { VerificationBtn } from "../components/button";
import { useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import FormField from "shared/ui/form-field";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useStore } from "zustand";
import { sessionStore } from "entities/session/model/sessionModel";
import Button from "shared/ui/button";
import { useVerificationStep } from "hooks/useVerificationStep";
import { KYC_Step } from "entities/account";
import { EntityType } from "static/types";
import { useSchema } from "helpers/functions";

const ValidationSchema = (entity: EntityType) => (t: any) =>
  Yup.object().shape(
    entity === EntityType.Entity
      ? { companyName: Yup.string().required(t("companyNameRequired")) }
      : {
          firstName: Yup.string().required(t("firstNameRequired")),
          lastName: Yup.string().required(t("lastNameRequired")),
        }
  );

export const DetailsPage = () => {
  const { t, i18n } = useTranslation("onboarding-auth");
  const { t: o } = useTranslation("onboarding");
  const { entity, user } = useStore(sessionStore);
  const { isLoading, onSubmit } = useVerificationStep<KYC_Step.Name>({
    step: KYC_Step.Name,
    navigateOnSuccess:
      entity === EntityType.Entity
        ? PATH_LIST.email
        : PATH_LIST.dateOfBirth,
  });
  const schema = useSchema(ValidationSchema(entity));

  return (
    <div className="verification-details">
      <div className="verification-details-main">
        <div className="verification-details-top">
          <p>
            {entity !== EntityType.Entity
              ? o("enterName")
              : t("enterCompanyName")}
          </p>
          {entity !== EntityType.Entity && <span>{o("exactlyAsInID")}</span>}
          <Formik
            initialValues={{
              firstName: user?.firstName || "",
              lastName: user?.lastName || "",
              companyName: user?.companyName || "",
            }}
            validationSchema={schema}
            onSubmit={(values) => {
              onSubmit({
                first_name: values.firstName,
                last_name: values.lastName,
                company_name: values.companyName,
              });
            }}
          >
            {(formik) => {
              const { errors, touched, isValid, dirty } = formik;
              return (
                <Form>
                  {entity !== EntityType.Entity ? (
                    <div className="name-lastname-wrapper">
                      <FormField
                        customClass="registration-field"
                        type="text"
                        id="firstName"
                        label={t("firstName")}
                        placeholder={t("enterFirstName")}
                        autoFocus={true}
                      />
                      <FormField
                        customClass="registration-field"
                        type="text"
                        id="lastName"
                        label={t("lastName")}
                        placeholder={t("enterLastName")}
                      />
                    </div>
                  ) : (
                    <FormField
                      customClass="registration-field"
                      type="text"
                      id="companyName"
                      label={t("companyName")}
                      placeholder={t("enterCompanyName")}
                      autoFocus={true}
                    />
                  )}

                  <VerificationBtn
                    type="submit"
                    disabled={!isValid || isLoading}
                    text={t("continue")}
                  />
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};
